import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import NavCard from '../components/NavCard';
import '../components/NavCard.css';
import { humanizeName } from '../utils/strings';

// Card image URLs (served from public folder)
const cardImages = {
  cover1: '/card-images/1.jpg',
  cover2: '/card-images/2.jpg',
  cover3: '/card-images/3.jpg',
  cover4: '/card-images/4.jpg',
  cover5: '/card-images/5.jpg',
  cover11: '/card-images/11.jpg',
  cover12: '/card-images/12.jpg',
  cover13: '/card-images/13.jpg',
  cover14: '/card-images/14.jpg',
  cover15: '/card-images/15.jpg',
  cover16: '/card-images/16.jpg',
  cover17: '/card-images/17.jpg',
  cover18: '/card-images/18.jpg'
};

export default function CategoryList() {
  const [items, setItems] = useState([]);
  const [covers, setCovers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [q, setQ] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    api('/api/categories').then(setItems).catch(setError).finally(()=>setLoading(false));
  }, []);
  useEffect(() => {
    // Local covers mapping; no network call
    setCovers({
      Agriculture: cardImages.cover1,
      General: cardImages.cover2,
      Insects: cardImages.cover3,
      Nature: cardImages.cover4,
      Rural: cardImages.cover5,
      'Agri Crops': cardImages.cover11,
      'Agri General': cardImages.cover12,
      'Agro Forestry': cardImages.cover13,
      'Animal Husbandry': cardImages.cover14,
      'Food Processing': cardImages.cover15,
      'Holticulture Crops': cardImages.cover16,
      'Medicinal Plants': cardImages.cover17,
      'Sericulture': cardImages.cover18
    });
  }, []);
  if (loading) return <div style={{padding:16}}>Loading…</div>;
  if (error) return <div style={{padding:16,color:'red'}}>Error: {String(error)}</div>;
  return (
    <div style={{padding:'28px 16px 16px'}}>
      <h2 style={{textAlign:'center', margin:'0 0 18px', fontSize:28}}>Categories</h2>
      <div style={{display:'flex', justifyContent:'center', margin:'0 0 18px'}}>
        <div className="search">
          <div className="search-box" style={{width:'min(560px, 92%)'}}>
            <input
              placeholder="Search images..."
              value={q}
              onChange={e=>setQ(e.target.value)}
              onKeyDown={e=>{ if (e.key==='Enter') navigate(`/search?q=${encodeURIComponent(q)}`); }}
            />
          </div>
        </div>
      </div>
      <div className="card-grid">
        {items.map(it => {
          const display = humanizeName(it.name);
          const coverUrl = covers[display];
          return (
            <NavCard key={it.name} to={`/downloads${it.path.replace('/api','')}`} name={display} coverUrl={coverUrl} />
          );
        })}
      </div>
    </div>
  );
}

